import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceOrder($orderReference: ID!, $cartId: UUID!) {
    marketplaceOrder(orderReference: $orderReference, cartId: $cartId) {
      orderReference
      status
      totalIncTax
      totalTax
      billingAddress {
        email
      }
      parcels {
        fulfilmentType
        fulfilmentLocation
        fulfilmentDayRange {
          min
          max
        }
        centreTitle
        centreServicePageURL
        shippingCost
        items {
          id
          name
          quantity
          shop {
            id
            name
          }
          quantity
          priceIncTax
          variant {
            sku
            category {
              title
            }
            optionValues {
              id
              optionId
              displayName
              value
            }
            title
            brand
            variantGroupCode
            price
            originalPrice
            discountPrice
            images {
              url
              description
            }
          }
        }
      }
    }
  }
`
